/**
 * Settings Modal for VariationFullImageAndBoxTrivia
 * Migrated to use shared SettingsModal pattern
 * Before: 115 lines | After: ~32 lines
 */
import { FC } from 'react';

import { ImageData } from '../VariationOne';
import { TEXT_POSITIONS } from '../VariationOne/SettingsModal';
import {
  SettingsModal as SharedSettingsModal,
  WATERMARK_SECTIONS,
  withWatermarkDefaults,
} from '../shared';

interface Props {
  image: ImageData;
  imageIndex: number;
  onClose: () => void;
  setImages: React.Dispatch<React.SetStateAction<ImageData[]>>;
}

const SettingsModal: FC<Props> = ({ image, ...props }) => (
  <SharedSettingsModal
    {...props}
    image={withWatermarkDefaults(image)}
    title="Image Parameters"
    sections={[
      ...WATERMARK_SECTIONS,
      {
        title: 'Text Position',
        type: 'radio',
        stateKey: 'textPosition',
        options: TEXT_POSITIONS,
      },
    ]}
  />
);

export default SettingsModal;
